import React from 'react';
import { Badge } from '../core/Badge.jsx';
import { IconButton } from '../core/IconButton.jsx';
import { PlayButton } from '../player/PlayButton.jsx';
import { CoverTile } from './CoverTile.jsx';

/**
 * Episode list row: cover · title+badges · one-line desc · mono meta · queue/play actions.
 * `locked` swaps the play button for a lock (member-only content for non-members).
 */
export function EpisodeRow({
  episode,
  current = false,
  playing = false,
  locked = false,
  showQueueButton = true,
  onPlay,
  onOpen,
  onQueue,
  className = '',
}) {
  const ep = episode || {};
  return (
    <div
      className={`bjl-eprow ${current ? 'is-current' : ''} ${className}`}
      onClick={() => onOpen && onOpen(ep.id)}
    >
      <CoverTile vol={ep.vol} size={56} seed={ep.id} image={ep.cover} fallback={ep.coverFallback} className="bjl-eprow__cover" />
      <div className="bjl-eprow__body">
        <div className="bjl-eprow__titleline">
          <span className="bjl-eprow__title">{ep.title}</span>
          {ep.isNew ? <Badge variant="new" /> : null}
          {ep.memberOnly ? <Badge variant="member" /> : null}
          {ep.hasVideo ? <Badge variant="video" /> : null}
        </div>
        {ep.desc ? <span className="bjl-eprow__desc">{ep.desc}</span> : null}
        <span className="bjl-eprow__meta">
          {ep.date ? <span>{ep.date}</span> : null}
          {ep.date && ep.durationMin != null ? <span className="bjl-dot"></span> : null}
          {ep.durationMin != null ? <span>{ep.durationMin} 分钟</span> : null}
          {ep.progress > 0 ? (
            <>
              <span className="bjl-dot"></span>
              <span className="bjl-eprow__progress"><i style={{ width: `${Math.min(100, ep.progress * 100)}%` }}></i></span>
              <span>已听 {Math.round(ep.progress * 100)}%</span>
            </>
          ) : null}
        </span>
      </div>
      <div className="bjl-eprow__actions" onClick={(e) => e.stopPropagation()}>
        {showQueueButton && !locked ? (
          <IconButton className="bjl-eprow__queue" icon="playlist_add" label="加入播放列表" onClick={() => onQueue && onQueue(ep.id)} />
        ) : null}
        {locked ? (
          <IconButton icon="lock" label="会员专享" variant="outline" onClick={() => onPlay && onPlay(ep.id)} />
        ) : (
          <PlayButton size="sm" playing={current && playing} onClick={() => onPlay && onPlay(ep.id)} />
        )}
      </div>
    </div>
  );
}
